export default {
  APPROVAL: "APPROVAL",
  DATA_LOG: "DATA_LOG",
};
